/* Nolvexastore theme behaviour */
(function () {
  "use strict";

  function moneyFormat(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  /* mobile navigation */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* product gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.dataset.full;
        main.alt = btn.dataset.alt || main.alt;
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  });

  /* tabs */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    wrap.querySelectorAll('[data-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.tab;
        wrap.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        wrap.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === id); });
      });
    });
  });

  /* qty steppers */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.step === 'up' ? 1 : -1;
        var min = parseInt(input.min || '1', 10);
        var v = parseInt(input.value, 10) || min;
        input.value = Math.max(min, v + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* variant picker */
  document.querySelectorAll('.product-form[data-variants]').forEach(function (form) {
    var jsonNode = form.querySelector('[data-variant-json]');
    if (!jsonNode) return;
    var data;
    try { data = JSON.parse(jsonNode.textContent); } catch (e) { return; }
    var select = form.querySelector('[data-variant-select]');
    var idField = form.querySelector('[name=id]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var submit = form.querySelector('[data-add]');
    function getCurrentVariant() {
      var id = select ? String(select.value) : String(idField.value);
      for (var i = 0; i < data.length; i++) {
        if (String(data[i].id) === id) return data[i];
      }
      return data[0] || null;
    }
    function syncVariantUI() {
      var v = getCurrentVariant();
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceNow) priceNow.textContent = v.price || '';
      if (priceWas) {
        priceWas.textContent = v.compare || '';
        priceWas.style.display = v.compare ? '' : 'none';
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? (submit.dataset.label || 'Add to cart') : (submit.dataset.soldout || 'Sold out');
      }
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: v }));
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    if (select) select.addEventListener('change', syncVariantUI);
    syncVariantUI();

  });

  /* collection sort */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location = url.toString();
    });
  }

  /* facets autosubmit */
  document.querySelectorAll('[data-facet-form] input').forEach(function (i) {
    i.addEventListener('change', function () { i.form.submit(); });
  });

  /* quick view modal */
  var qvModal = document.getElementById('QuickViewModal');
  if (qvModal) {
    var qvImage = qvModal.querySelector('[data-quickview-image]');
    var qvTitle = qvModal.querySelector('[data-quickview-title]');
    var qvPrice = qvModal.querySelector('[data-quickview-price]');
    var qvCompare = qvModal.querySelector('[data-quickview-compare]');
    var qvLink = qvModal.querySelector('[data-quickview-link]');
    var qvAdd = qvModal.querySelector('[data-quickview-add]');
    var qvVariantId = null;

    function closeQuickView() {
      qvModal.hidden = true;
      document.body.style.overflow = '';
    }
    function openQuickView(btn) {
      qvModal.hidden = false;
      document.body.style.overflow = 'hidden';
      qvImage.src = btn.dataset.image || '';
      qvImage.alt = btn.dataset.title || 'Product image';
      qvTitle.textContent = btn.dataset.title || '';
      qvPrice.textContent = btn.dataset.price || '';
      qvCompare.textContent = btn.dataset.compare || '';
      qvCompare.style.display = btn.dataset.compare ? '' : 'none';
      qvLink.href = btn.dataset.url || '#';
      qvVariantId = btn.dataset.variantId || null;

      /* Expose the selected quick-view product to the cross-store bridge. */
      qvAdd.dataset.productUrl = btn.dataset.url || '';
      qvAdd.dataset.variantId = btn.dataset.variantId || '';
      if (btn.dataset.hasOptions === 'true') {
        qvAdd.textContent = 'View options on product page';
        qvAdd.disabled = false;
        qvAdd.dataset.mode = 'link';
      } else if (btn.dataset.available !== 'true') {
        qvAdd.textContent = 'Sold out';
        qvAdd.disabled = true;
        qvAdd.dataset.mode = 'disabled';
      } else {
        qvAdd.textContent = 'Add to cart';
        qvAdd.disabled = false;
        qvAdd.dataset.mode = 'add';
      }
    }

    document.querySelectorAll('[data-quick-view]').forEach(function (btn) {
      btn.addEventListener('click', function () { openQuickView(btn); });
    });
    qvModal.querySelectorAll('[data-quickview-close]').forEach(function (btn) {
      btn.addEventListener('click', closeQuickView);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !qvModal.hidden) closeQuickView();
    });
    qvAdd.addEventListener('click', function () {
      if (qvAdd.dataset.mode === 'link') {
        window.location.href = qvLink.href;
        return;
      }
      if (qvAdd.dataset.mode !== 'add' || !qvVariantId) return;
      var fd = new FormData();
      fd.append('id', qvVariantId);
      fd.append('quantity', '1');
      qvAdd.disabled = true;
      qvAdd.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
        .then(function () {
          qvAdd.textContent = 'Added ✓';
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart) {
            document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
            document.querySelectorAll('.cart-total').forEach(function (el) { el.textContent = moneyFormat(cart.total_price); });
          }
          setTimeout(closeQuickView, 900);
        })
        .catch(function () {
          qvAdd.disabled = false;
          qvAdd.textContent = 'Try again';
        });
    });
  }

  /* sticky product purchase bar */
  document.querySelectorAll('.product-form[data-variants]').forEach(function (form) {
    var sticky = document.querySelector('[data-sticky-bar]');
    if (!sticky) return;
    sticky.hidden = false;
    sticky.classList.add('is-visible');
    var anchor = form.querySelector('[data-sticky-anchor]') || form.querySelector('[data-add]');
    var idField = form.querySelector('[name=id]');
    var addSource = form.querySelector('[data-add]');
    var stickyAdd = sticky.querySelector('[data-sticky-add]');
    var stickyPrice = sticky.querySelector('[data-sticky-price]');
    var stickyCompare = sticky.querySelector('[data-sticky-compare]');
    var variants = [];
    try { variants = JSON.parse(form.querySelector('[data-variant-json]').textContent); } catch (e) {}

    function currentVariant() {
      var id = idField ? String(idField.value) : '';
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i];
      return variants[0] || null;
    }
    function syncSticky() {
      var v = currentVariant();
      if (!v) return;
      if (stickyPrice) stickyPrice.textContent = v.price || '';
      if (stickyCompare) {
        stickyCompare.textContent = v.compare || '';
        stickyCompare.style.display = v.compare ? '' : 'none';
      }
      if (stickyAdd) {
        stickyAdd.disabled = !v.available;
        stickyAdd.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }
    syncSticky();
    document.addEventListener('variant:changed', syncSticky);

    sticky.hidden = false;
    sticky.classList.add('is-visible');

    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      if (addSource && !addSource.disabled) addSource.click();
    });
  });
})();
